import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HelpStore from '../../stores/HelpStore';
import StepHeader from '../../includes/StepHeader';
import NonBCustomerError from '../common/NonBCustomerError';
import HelpActionCreator from '../../actions/HelpActionCreator';
import BrowserUtils from '../../utils/BrowserUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import UserManagementStore from '../../stores/UserManagementStore';

let headerContent = 'Terms & Conditions';
let bodyContent1 =
  'We were unable to load your Terms & Conditions at this time.';
let bodyContent2 = '';

class TermsCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      component: 'AnyQuestions',
      showModal: false,
      showTermsCondition: HelpStore.getShowTC(),
      TCError: HelpStore.getTCError(),
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    sayLandingMessage('Terms and Conditions');
    window.scrollTo(0, 0);
  }

  getData() {
    return (
      <div>
        {BrowserUtils.isTabletLanscapeView() ? (
          <div>
            <a href={this.props.TCData} target="_blank" rel="noreferrer">
              {this.props.content.DownloadTermsCondition}{' '}
            </a>
          </div>
        ) : (
          <object
            type="application/pdf"
            data={this.props.TCData}
            height="900px"
            width="100%"
            style={{ height: '900px', width: '100%' }}
          />
        )}
      </div>
    );
  }

  retryServices() {
    HelpActionCreator.getTcData(); // Invokes service call to get TC
  }

  showErrorPage() {
    return (
      <div>
        <NonBCustomerError
          headerContent={headerContent}
          buttonName2="Retry"
          bodyContent1={bodyContent1}
          bodyContent2={bodyContent2}
          handleButtonClick2={this.retryServices}
          headerFlag
          hideButton1
          componentName
          page={false}
        />
      </div>
    );
  }

  render() {
    return this.state.TCError === true ? (
      this.showErrorPage()
    ) : (
      <div className="page page-home bow layout layout@xlarge layout--centered terms-conditions-page-template">
        <div className="layout__inner">
          <div className="container" id="site-main" role="main" tabIndex="-1">
            <div className="row">
              <div className="col-md1-24">
                <div>
                  <StepHeader
                    showheaderCrumbs
                    onClick={this.props.closed}
                    headerCrumbsMessage="Back"
                    headerTitle={
                      UserManagementStore.isSMEUser()
                        ? this.props.content.AuthorisedUserTerm
                        : this.props.content.TermsConditionPageTitle
                    }
                  />
                  <div className="row">
                    <div className="col-md1-24 col-sm1-24">
                      {this.getData()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TermsCondition.propTypes = {
  onClick: PropTypes.func,
  closed: PropTypes.func,
};
TermsCondition.defaultProps = {
  onClick() {
    return null;
  },
};

export default TermsCondition;
